export function isPageVisible(page) {
  return page.visible;
}
